export default getText => key =>
  ({
    appointments: getText('Appointments', 'Schedule_Tabs_Header'),
    schedules: getText('Schedules', 'Schedules_Tabs_Header'),
  }[key])
